import React from "react";
import "./topbar.scss";

export default function Topbar(){
  return(
    <div className="topbar">
     <div className="wrapper">
       <div className="left">
       <a href=""><img src="assets/lLogo.png" className="lev-logo"/></a>
        </div>
        <div className="right">
        <button type="button" className="btn btn-outline-success">
        <img src="assets/whatsapp.png" alt="whatsapp" className="whatsapp-logo"/>Call us @ 1800572000</button>
        </div>
     </div>
    </div>
  )
}
